var cov_1weeaf4w2z = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/select.ts",
      hash = "9fe70ecc94ca7424cc2cef695d32c86561b502ef",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/select.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "1": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "2": {
        start: {
          line: 12,
          column: 34
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "3": {
        start: {
          line: 13,
          column: 31
        },
        end: {
          line: 13,
          column: 33
        }
      },
      "4": {
        start: {
          line: 14,
          column: 32
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "5": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 23,
          column: 4
        }
      },
      "6": {
        start: {
          line: 17,
          column: 14
        },
        end: {
          line: 17,
          column: 61
        }
      },
      "7": {
        start: {
          line: 17,
          column: 34
        },
        end: {
          line: 17,
          column: 60
        }
      },
      "8": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "9": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 21,
          column: 23
        }
      },
      "10": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 39
        }
      },
      "11": {
        start: {
          line: 21,
          column: 11
        },
        end: {
          line: 21,
          column: 23
        }
      },
      "12": {
        start: {
          line: 24,
          column: 51
        },
        end: {
          line: 24,
          column: 64
        }
      },
      "13": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "splitSelecteds",
        decl: {
          start: {
            line: 6,
            column: 24
          },
          end: {
            line: 6,
            column: 38
          }
        },
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 20
          },
          end: {
            line: 16,
            column: 21
          }
        },
        loc: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 34
          },
          end: {
            line: 17,
            column: 60
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 29
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 29
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 23
          }
        }, {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 23
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { getKey } from '../utils/uid';
export default function splitSelecteds(selecteds, props) {
  cov_1weeaf4w2z.f[0]++;
  cov_1weeaf4w2z.s[0]++;

  if (!selecteds) {
    cov_1weeaf4w2z.b[0][0]++;
    cov_1weeaf4w2z.s[1]++;
    return null;
  } else {
    cov_1weeaf4w2z.b[0][1]++;
  }

  var _ref = (cov_1weeaf4w2z.s[2]++, props),
      data = _ref.data,
      keygen = _ref.keygen,
      datum = _ref.datum;

  var left = (cov_1weeaf4w2z.s[3]++, []);
  var right = (cov_1weeaf4w2z.s[4]++, []);
  cov_1weeaf4w2z.s[5]++;
  selecteds.forEach(function (s) {
    cov_1weeaf4w2z.f[1]++;
    var v = (cov_1weeaf4w2z.s[6]++, data.find(function (d, i) {
      cov_1weeaf4w2z.f[2]++;
      cov_1weeaf4w2z.s[7]++;
      return getKey(d, keygen, i) === s;
    }));
    cov_1weeaf4w2z.s[8]++;

    if (v) {
      cov_1weeaf4w2z.b[1][0]++;
      cov_1weeaf4w2z.s[9]++;

      if (datum.check(v)) {
        cov_1weeaf4w2z.b[2][0]++;
        cov_1weeaf4w2z.s[10]++;
        right.push(s);
      } else {
        cov_1weeaf4w2z.b[2][1]++;
        cov_1weeaf4w2z.s[11]++;
        left.push(s);
      }
    } else {
      cov_1weeaf4w2z.b[1][1]++;
    }
  });
  var result = (cov_1weeaf4w2z.s[12]++, [left, right]);
  cov_1weeaf4w2z.s[13]++;
  return result;
}